/**
 * Controller for managing the preferences modal for tabs.
 * This class handles the initialization, user interactions, and state management of the modal.
 */
class TabPreferencesModalController {
    /**
     * Constructor for TabPreferencesModalController.
     * @param {Object} $scope - Angular scope object.
     * @param {Object} $uibModalInstance - UI Bootstrap modal instance.
     * @param {Array} tabs - List of tabs.
     * @param {Array} rows - List of rows.
     * @param {Object} contentObj - Content object containing data.
     * @param {Object} deleteTabModalOptions - Options for the delete tab modal.
     * @param {Object} $signals - Signal emitter service.
     * @param {Object} TaskDataService - Service for task data operations.
     * @param {Object} $uibModal - UI Bootstrap modal service.
     * @param {Object} DeleteObjectHelperService - Service for deleting objects.
     * @param {Object} TaskInfoService - Service for task information.
     */
    constructor($scope, $uibModalInstance, tabs, rows, contentObj, deleteTabModalOptions, $signals, TaskDataService, $uibModal, DeleteObjectHelperService, TaskInfoService) {
        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;
        this.tabs = tabs;
        this.rows = rows;
        this.contentObj = contentObj;
        this.deleteTabModalOptions = deleteTabModalOptions;
        this.$signals = $signals;
        this.TaskDataService = TaskDataService;
        this.$uibModal = $uibModal;
        this.DeleteObjectHelperService = DeleteObjectHelperService;
        this.TaskInfoService = TaskInfoService;

        this._taskContext = TaskDataService.fetchContext();
        this.taskInfo = TaskInfoService.getTaskInfo();
        this.$scope.writingDirection = this.taskInfo.getInputLanguage().writingDirection;

        this.$scope.tabs = angular.copy(contentObj.data.tabs);
        this.$scope.tabContentObj = {};
        this.$scope.showPreferences = false;

        this.deleteTabObjects = [];

        this.init();

        $scope.openPreferences = this.openPreferences.bind(this);
        $scope.onCancelButton = this.onCancelButton.bind(this);
        $scope.onConfirm = this.onConfirm.bind(this);
        $scope.getTabContent = this.getTabContent.bind(this);
        $scope.onDeleteTab = this.onDeleteTab.bind(this);
    }

    /**
     * Initializes the modal by setting up the tab content objects.
     */
    init() {
        this.$scope.tabContentObj = {};
        angular.forEach(this.$scope.tabs, (tab, tabKey) => {
            this.$scope.tabContentObj[tab.content] = angular.copy(this._taskContext.read(tab.content));
            delete tab.popoverText;
        });

        this.deleteTabObjects = [];
    }

    /**
     * Opens the preferences for a specific tab.
     * @param {number} index - Index of the tab to open preferences for.
     */
    openPreferences(index) {
        if (this.$scope.activeTabEdit === index) {
            this.$scope.activeTabEdit = -1;
        } else {
            this.$scope.activeTabEdit = index;
        }
    }

    /**
     * Handles the cancel button click event.
     * Dismisses the modal.
     */
    onCancelButton() {
        this.$uibModalInstance.dismiss('cancel');
    }

    /**
     * Handles the confirm button click event.
     * Updates the content object, task context, and deletes necessary objects.
     * Emits a signal to re-render the rows and dismisses the modal.
     */
    onConfirm() {
        this.contentObj.data.tabs = this.$scope.tabs;
        angular.forEach(this.$scope.tabContentObj, (tab, tabKey) => {
            this._taskContext.update(tabKey, tab.data);
        });

        angular.forEach(this.deleteTabObjects, (containerEntry, key) => {
            this.DeleteObjectHelperService.deleteSubcontainerByEntry(containerEntry);
        });

        this.$signals.emit("rendering_rows", this.rows);
        this.$uibModalInstance.dismiss('cancel');
    }

    /**
     * Retrieves the content for a specific tab.
     * @param {string} uuid - UUID of the tab.
     * @returns {Object} - Content object for the tab.
     */
    getTabContent(uuid) {
        console.log(uuid, this.$scope.tabContentObj[uuid]);
        return this.$scope.tabContentObj[uuid];
    }

    /**
     * Handles the delete tab event.
     * Opens a confirmation modal if necessary and deletes the tab.
     * @param {string} tabUUID - UUID of the tab to delete.
     */
    onDeleteTab(tabUUID) {
        let cancelForeach = false;
        angular.forEach(this.$scope.tabs, (tab, tabKey) => {
            if (tab.content === tabUUID && !cancelForeach) {
                let _tabContent = this._taskContext.read(tab.content);
                if (Object.keys(_tabContent.getObjects()).length > 0) {
                    let deleteTabModalInstance = this.$uibModal.open(this.deleteTabModalOptions);

                    deleteTabModalInstance.result.then(() => {
                    }, () => {
                        if (deleteTabModalInstance.delete) {
                            this.deleteTabObjects.push(this._taskContext.read(this.$scope.tabs[tabKey].content));
                            this.$scope.tabs.splice(tabKey, 1);
                        }
                    });

                } else {
                    this.deleteTabObjects.push(this._taskContext.read(this.$scope.tabs[tabKey].content));
                    this.$scope.tabs.splice(tabKey, 1);
                }
                cancelForeach = true;
                return true;
            }
        });
    }
}

export default TabPreferencesModalController;